import { render, staticRenderFns } from "./CreateUserForm.vue?vue&type=template&id=352735e1&scoped=true"
import script from "./CreateUserForm.vue?vue&type=script&lang=js"
export * from "./CreateUserForm.vue?vue&type=script&lang=js"
import style0 from "./CreateUserForm.vue?vue&type=style&index=0&id=352735e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352735e1",
  null
  
)

export default component.exports